import React, { useRef, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  messages,
} from "@mui/material";
import { TextField } from "@mui/material";

import { withStyles } from "@mui/styles";
import ColoredButton from "../../../shared/components/ColoredButton";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const styles = (theme) => ({
  termsConditionsListitem: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
  },
  dialogActions: {
    justifyContent: "flex-start",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  backIcon: {
    marginRight: theme.spacing(1),
  },
});

function ContactoDialog(props) {
  const {
    classes,
    onClose,
    theme,
    addContacto,
    errors,
    landing,
    pushMessageToSnackbar,
    messages,
  } = props;
  const nombre = useRef();
  const celular = useRef();
  const comentarios = useRef();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (landing && Object.keys(landing.contacto).length > 0 && loading) {
      onClose();
      pushMessageToSnackbar({
        text: messages.mensaje_exito_contacto,
      });
    }
  }, [landing.contacto]);

  const sendContacto = useCallback(() => {
    const userData = {
      nombre: nombre.current.value,
      celular: celular.current.value,
      comentarios: comentarios.current.value,
    };
    setLoading(true);
    addContacto(userData);
  }, [addContacto, loading]);

  return (
    <Dialog
      open
      scroll="paper"
      TransitionComponent={Transition}
      onClose={onClose}
      hideBackdrop
      keepMounted
    >
      <DialogTitle>
        <Typography variant="h5" color="primary" paragraph>
          {messages.datos_de_contacto}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TextField
          id="outlined-basic"
          label={messages.nombre}
          inputRef={nombre}
          variant="outlined"
          sx={{ mb: "10px", mt: "10px" }}
          error={errors.nombre ? true : false}
          helperText={errors.nombre}
          fullWidth
          required
        />
        <TextField
          id="outlined-basic"
          label={messages.celular}
          inputRef={celular}
          variant="outlined"
          sx={{ mb: "10px" }}
          fullWidth
          required
          error={errors.celular ? true : false}
          helperText={errors.celular}
        />
        <TextField
          id="outlined-basic"
          label={messages.comentarios}
          inputRef={comentarios}
          variant="outlined"
          sx={{ mb: "10px" }}
          fullWidth
          multiline
          required
          error={errors.comentarios ? true : false}
          helperText={errors.comentarios}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <ColoredButton
          onClick={onClose}
          variant="outlined"
          color={theme.palette.primary.main}
        >
          {messages.cerrar}
        </ColoredButton>
        <Button
          onClick={() => {
            sendContacto();
          }}
          variant="contained"
        >
          {messages.enviar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ContactoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  addContacto: PropTypes.func.isRequired,
  landing: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  pushMessageToSnackbar: PropTypes.func,
  messages: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ContactoDialog);
